import { QueryClient, QueryClientProvider as RQQueryClientProvider } from '@tanstack/react-query';
import { FC, PropsWithChildren } from 'react';

import { defaultQueryClientOptions } from '@hooks/QueryHooks';

export const queryClient = new QueryClient({
    defaultOptions: defaultQueryClientOptions,
});

export const QueryClientProvider: FC<PropsWithChildren> = ({ children }) => {
    return <RQQueryClientProvider client={queryClient}>{children}</RQQueryClientProvider>;
};
